import {createSelector} from 'reselect'

const emptyObj = {}

export const lookupInAPI = (itemKey, state) => {
  return (
    (state && state.api && state.api[itemKey] && state.api[itemKey].data) ||
    emptyObj
  )
}

export const getApiTopics = (state) => lookupInAPI('topics', state)
export const getApiTimelines = (state) => lookupInAPI('timelines', state)
export const getApiFiles = (state) => lookupInAPI('files', state)
export const getApiAccounts = (state) => lookupInAPI('accounts', state)
export const getApiCredentials = (state) => lookupInAPI('credentials', state)
export const getApiCalls = (state) => lookupInAPI('calls', state)
export const getApiChats = (state) => lookupInAPI('chats', state)
export const getApiNotes = (state) => lookupInAPI('notes', state)
export const getApiStatuses = (state) => lookupInAPI('statuses', state)
export const getApiAddContactRequests = (state) =>
  lookupInAPI('add_contact_requests', state)
export const getApiTasks = (state) => lookupInAPI('tasks', state)
export const getApiMeetings = (state) => lookupInAPI('meetings', state)
export const getApiIntegrations = (state) => lookupInAPI('integrations', state)

export const getApiParticipants = (state) => lookupInAPI('participants', state)
export const getApiCallParticipants = (state) =>
  lookupInAPI('call_participants', state)
export const getApiContacts = (state) => lookupInAPI('contacts', state)
export const getApiUsers = (state) => lookupInAPI('users', state)

export const getApiWebsocketNotifications = (state) =>
  lookupInAPI('websocket_notifications', state)

export const getApiOutgoingEmails = (state) =>
  lookupInAPI('outgoing_emails', state)

export const getApiMembers = (state) => lookupInAPI('members', state)

export const getApiPublicContacts = (state) =>
  lookupInAPI('public_contacts', state)
export const getApiHandles = (state) => lookupInAPI('handles', state)

export const getApiBadges = (state) => lookupInAPI('badges', state)
export const getApiBadgesLookup = (state) =>
  state?.api?.badges?.lookup || emptyObj

export const getApiTokens = (state) => lookupInAPI('tokens', state)
export const getApiWelcomeMessages = (state) => lookupInAPI('welcome_messages', state)
export const getApiQuestions = (state) => lookupInAPI('questions', state)
export const getApiAnswers = (state) => lookupInAPI('answers', state)
export const getApiVideoCollections = (state) => lookupInAPI('video_collections', state)
export const getApiVideoCollectionItems = (state) => lookupInAPI('video_collection_items', state)

export const getContactsLookup = (state) =>
  state?.api?.contacts?.lookup || emptyObj
export const getPublicContactsLookup = (state) =>
  state?.api?.public_contacts?.lookup || emptyObj

const getRecord = (apiSlice) => () =>
  createSelector([apiSlice, (_, id) => id], (records, id) => {
    return records[id]
  })

export const makeGetChat = getRecord(getApiChats)
export const makeGetCall = getRecord(getApiCalls)
export const makeGetNote = getRecord(getApiNotes)
export const makeGetStatus = getRecord(getApiStatuses)
export const makeGetAddContactRequest = getRecord(getApiAddContactRequests)
